import {faFacebookSquare} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {PureComponent} from 'react';
import {Carousel, Col, Container, Row} from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor';
import styled from 'styled-components';
import {SOCIAL_NETWORK, STORES} from '../../common/constants';
import appStore from '../assets/img/appstore-badge.svg';
import prevIcon from '../assets/img/chevron-left.svg';
import nextIcon from '../assets/img/chevron-right.svg';
import cleanbillPlatforms from '../assets/img/cleanbill-platforms.png';
import cleanbillStores from '../assets/img/cleanbill-stores.png';
import active_dot from '../assets/img/dot-active.png';
import dot from '../assets/img/dot-normal.png';
import googlePlay from '../assets/img/google-play-badge.png';
import phone from '../assets/img/smartphone01.png';
import waveGroup from '../assets/img/wave_group.png';

const Content = styled.div`
  padding-top: 90px;
`;

class PresentationComp extends PureComponent {
  state = {
    index: 0,
  };

  handleSelect = selectedIndex => {
    this.setState({
      index: selectedIndex,
    });
  };

  indicators = () => {
    const {index} = this.state;
    return (
      <div className="slider-dots">
        <img src={index === 0 ? active_dot : dot} alt="dot" className="dot clickable"
          onClick={() => this.handleSelect(0)}/>
        <img src={index === 1 ? active_dot : dot} alt="dot" className="dot clickable"
          onClick={() => this.handleSelect(1)}/>
        <img src={index === 2 ? active_dot : dot} alt="dot" className="dot clickable"
          onClick={() => this.handleSelect(2)}/>
      </div>
    );
  };

  appStores = (
    <div className="download-section">
      Application disponible sur :
      <div className="store-buttons">
        <a href={STORES.APPLE_APP_STORE} target="_blank" rel="noopener noreferrer">
          <img src={appStore} alt="app-store-download" className="apple-store-badge"/>
        </a>
        <a href={STORES.GOOGLE_PLAY_STORE} target="_blank" rel="noopener noreferrer">
          <img src={googlePlay} alt="google-play-download" className="google-play-badge"/>
        </a>
      </div>
    </div>
  );

  prev = (
    <div className="icon-container">
      <img src={prevIcon} alt="prev" className="prev-icon"/>;
    </div>
  );

  next = (
    <div className="icon-container">
      <img src={nextIcon} alt="next" className="next-icon"/>;
    </div>
  );

  render() {
    const {index} = this.state;
    return (
      <Content>
        <ScrollableAnchor id={'presentation'}>
          <Container className="container-full presentation-container">
            <img src={waveGroup} className="wave-background" alt="Waves background"/>
            <Carousel
              indicators={false}
              prevIcon={this.prev}
              nextIcon={this.next}
              activeIndex={index}
              onSelect={this.handleSelect}
              interval={null}
            >
              <Carousel.Item>
                <Row>
                  <Col xs={12} md={6} className="presentation-item-container">
                    <div className="presentation-text">
                      <div>
                        <span className="bold-word">Tickets de caisse</span> et
                      </div>
                      <div><span className="bold-word">Cartes de fidélité</span></div>
                      <div>
                        La seule app<br/>pour les gérer tous!
                      </div>
                    </div>
                    {this.appStores}
                    {this.indicators()}
                  </Col>
                  <Col md={6} className="d-md-flex d-none align-self-center">
                    <img src={phone} className="carousel-right-img-1" alt="phone"/>
                  </Col>
                </Row>
              </Carousel.Item>
              <Carousel.Item>
                <Row>
                  <Col xs={12} md={6} className="presentation-item-container">
                    <div className="presentation-text">
                      <div>
                        Clean Bill est l’application qu’il vous faut pour un
                      </div>
                      {this.appStores}
                      {this.indicators()}
                    </div>
                  </Col>
                  <Col md={6} className="d-md-flex d-none align-self-center">
                    <img src={cleanbillPlatforms} className="carousel-right-img-2" alt="browser-demo"/>
                  </Col>
                </Row>
              </Carousel.Item>
              <Carousel.Item>
                <Row>
                  <Col xs={12} md={6} className="presentation-item-container">
                    <div className="presentation-text">
                      <div>
                        Clean Bill un classeur<br/>en ligne pour stocker
                      </div>
                      <div><span className="bold-word">vos factures et<br/>tickets de caisse</span></div>
                    </div>
                    {this.appStores}
                    {this.indicators()}
                  </Col>
                  <Col md={6} className="d-md-flex d-none align-self-center">
                    <img src={cleanbillStores} className="carousel-right-img-3" alt="stores"/>
                  </Col>
                </Row>
              </Carousel.Item>
            </Carousel>
            <div className="sub-carousel">
              <a className="facebook-link" href={SOCIAL_NETWORK.FACEBOOK} target="_blank"
                rel="noopener noreferrer">
                <span className="bold-word">Suivez-nous sur </span><FontAwesomeIcon icon={faFacebookSquare}
                  color={'white'} size={'lg'}/>
              </a>
            </div>
          </Container>
        </ScrollableAnchor>
      </Content>
    );
  }
}

export default PresentationComp;
